<template>
  <div v-if="!isHidden" class="modal micromodal-slide" :class="{'is-open': isOpen}">
    <div class="modal__overlay"></div>
    <div class="modal_item">
      <button @click="close" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <div id="js-error_wrap" class="error_wrap">
        <div v-if="message != ''">
          <p class="error_text ab" v-html="message"></p>
        </div>
      </div>
      <div class="model_wrap">
        <input class="kodomo_check" type="checkbox" v-model="doNotShowAgain" v-bind:id="modalCheckboxId" v-bind:checked="doNotShowAgain"/>
        <label class="checkbox01" v-bind:for="modalCheckboxId" v-bind:checked="doNotShowAgain">次回からこのメッセージは表示しない</label>
      </div>
      <div class="service_wrap pb48">
        <button @click="closeTransition" class="btn_blue">はい</button>
        <br/>
        <button @click="close" class="btn_delete">いいえ</button>
      </div>
    </div>
  </div>
</template>

<script>
import scrollPosition from '@/model/scrollPosition';

export default {
  props: ['message', 'modalCheckboxId'],
  data() {
    return {
      isOpen: true,
      isHidden: false,
      doNotShowAgain: false,
    };
  },
  created() {
    if (localStorage.getItem('doNotShowModal') === 'true') {
      this.isHidden = true;
    }
  },
  methods: {
    close() {
      scrollPosition.close();
      // if (this.doNotShowAgain) {
      //   localStorage.setItem('doNotShowModal', 'true');
      // }
      this.$emit('modalClose');
    },
    closeTransition() {
      scrollPosition.close();
      console.log('closeTransition');
      if (this.doNotShowAgain) {
        localStorage.setItem('doNotShowModal', 'true');
      }
      this.$emit('modalCloseTransition');
    },
    open() {
      scrollPosition.open();
      this.isOpen = true;
    },
  },
};
</script>

<style lang="css" scoped>
.error_wrap {
  padding: 60px 16px 16px;
  text-align: center;
}
.modal_item {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  border-radius: 12px;
  height: 400px;
  margin: auto;
  overflow: hidden;
  right: 0;
  top: 0;
  width: 91%;
}
.small {
  font-size: 13px;
}

.model_wrap {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SwitchDialogModal.vue